import React from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { EmpresaHub, AbaHub } from './EmpresaHub';
import { EmpresasLista } from './EmpresasLista';

const DASHBOARD = '/modulesHome/accountingConciliation/conciliacao-contabil';
const ABAS_VALIDAS: AbaHub[] = ['visao', 'contas', 'contexto', 'memoria'];

/**
 * Página Empresas: lista cross-empresa (master) ⇄ hub por-empresa (detalhe).
 * O estado vive na URL — `?empresa=<id>` abre o hub, `?tab=<aba>` a seção.
 * Uma rota só; sem param de path (compatível com o registro estático).
 *
 * Navegação: clicar num card empurra histórico (push) — então "Voltar" no hub
 * retorna à lista, e na lista retorna à origem (segue o fluxo). Troca de aba é
 * `replace` para não poluir o histórico.
 */
export function ConciliacaoContabilEmpresasPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [params, setParams] = useSearchParams();
  const empresaParam = params.get('empresa');
  const empresaId = empresaParam && /^\d+$/.test(empresaParam) ? Number(empresaParam) : null;
  const tabParam = params.get('tab') as AbaHub | null;
  const aba: AbaHub = tabParam && ABAS_VALIDAS.includes(tabParam) ? tabParam : 'visao';

  const voltarLista = () => {
    if (location.key !== 'default') navigate(-1);
    else navigate(DASHBOARD);
  };
  const voltarHub = () => {
    // Veio da lista (push) -> volta a ela pelo histórico; senão limpa o param.
    if (location.key !== 'default') navigate(-1);
    else setParams({});
  };

  if (empresaId == null) {
    return (
      <EmpresasLista
        onSelecionar={id => setParams({ empresa: String(id) })}
        onVoltar={voltarLista}
      />
    );
  }

  return (
    <EmpresaHub
      empresaId={empresaId}
      aba={aba}
      onAba={a => setParams({ empresa: String(empresaId), tab: a }, { replace: true })}
      onVoltar={voltarHub}
    />
  );
}
